import { Price } from '@jouzen/ecom-components/v3/Price';
import { Typography } from '@jouzen/ecom-components/v3/Typography';

import RichText from '@/app/components/RichText';
import useMembershipPricing from '@/app/hooks/useMembershipPricing';
import { useLowestRingsPricing } from '@/queries/LowestRingsPricing';

const RingPrice = ({
  price,
}: {
  readonly price:
    | { amount: number | null; currencyCode: string | null }
    | null
    | undefined;
}) => {
  if (price?.amount && price.currencyCode) {
    return <Price currencyCode={price.currencyCode} price={price.amount} />;
  }
  return null;
};

const FsaProductDetails = () => {
  const membershipPricing = useMembershipPricing({ showCurrency: false });
  const { data: ringPricing } = useLowestRingsPricing();
  const membershipPrice = membershipPricing['monthlyCost']!;

  return (
    <article>
      <Typography Element="h1" variant="h3" className="mb-1">
        <RichText messageKey="comparisons_oura_title" />
      </Typography>

      <Typography Element="h2" variant="h5" className="mb-4 leading-tight">
        <RichText messageKey="heart_rate_monitoring_slideshow_description" />
      </Typography>

      <Typography>
        <RichText
          messageKey="heart_rate_monitoring_pricing_details_v2"
          tValues={{
            membershipPrice,
            ringPrice: () => <RingPrice price={ringPricing?.price} />,
          }}
        />
      </Typography>

      <div className="mt-6 border-t border-gray-200 px-2 pt-4">
        <ul className="mb-4 ml-6 list-disc">
          <li className="mb-2">
            <RichText messageKey="heart_rate_monitoring_listitem_1" />
          </li>
          <li className="mb-2">
            <RichText messageKey="heart_rate_monitoring_listitem_2" />
          </li>
          <li className="mb-2">
            <RichText messageKey="heart_rate_monitoring_listitem_3" />
          </li>
          <li className="mb-2">
            <RichText messageKey="heart_rate_monitoring_listitem_4" />
          </li>
        </ul>

        <Typography>
          <RichText
            messageKey="heartrate_monitoring_pricing_note_v2"
            tValues={{
              membershipPrice,
            }}
          />
        </Typography>
      </div>
    </article>
  );
};

export default FsaProductDetails;
